'use strict';
var novicell = novicell || {};

novicell.ratingSlide = novicell.ratingSlide || function () {

    function init() {
        ratingSlide();
    }

    function ratingSlide() {
        let controls = document.querySelectorAll('.rating-control');
        if (controls.length > 0) {
            controls.forEach(control => {
                let $container = jQuery(control);
                $container.append('<div class="slider-container"></div>');
                let slider = jQuery('input[type=range]', $container);
                let hint = jQuery('.wpforms-field-number-slider-hint', $container);
                let $sliderCon = jQuery('.slider-container', $container);
                if (slider.length > 0) {
                    $sliderCon.append(emojiHtml());
                    slider.appendTo($sliderCon);
                    hint.appendTo($sliderCon);
                    let value = slider.val();
                    let $emojis = slider.siblings('.rating-emoji');
                    jQuery('li:nth-child('+ value+') .emoji-icon', $emojis).addClass('active');
                }

                slider.on('change', function(){
                    let $slide = jQuery(this);
                    let $emojis = $slide.siblings('.rating-emoji');

                    let value = $slide.val();
                    jQuery('.emoji-icon', $emojis).removeClass('active');
                    jQuery('li:nth-child('+ value+') .emoji-icon', $emojis).addClass('active');
                });

                jQuery('.emoji-icon').on('click', function (){
                    let $icon = jQuery(this);
                    let value = $icon.data('rating');
                    let $parent = $icon.closest('.rating-emoji')
                    let $slider = $parent.siblings('input[type=range]');
                    $slider.val(value);
                    $slider.change();
                    jQuery('.emoji-icon', $parent).removeClass('active');
                    $icon.addClass('active');
                })
            });
        }
    }

    function emojiHtml() {
        let html = `<ul class="rating-emoji">
                  <li><span class="emoji-icon" data-rating="1"><span class="emoji-num">1</span> &#128553;</span></li>
                  <li><span class="emoji-icon" data-rating="2"><span class="emoji-num">2</span> &#128533;</span></li>
                  <li><span class="emoji-icon" data-rating="3"><span class="emoji-num">3</span> &#128529;</span></li>
                  <li><span class="emoji-icon" data-rating="4"><span class="emoji-num">4</span> &#128522;</span></li>
                  <li><span class="emoji-icon" data-rating="5"><span class="emoji-num">5</span> &#128525;</span></li>
             </ul>`;

        return html;
    }

    return {
        init: init,
        ratingSlide: ratingSlide
    };

}();
